import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const OverlineLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 11,
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: 0.7,
  textTransform: 'uppercase',
}));
